import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import { KPIRulePartial, NextToken } from '../../_types/types.type';

interface ListKPIByOrgResponse {
  listKPIRulesByOrg: {
    items: KPIRulePartial[];
    nextToken: NextToken;
  };
}

interface ListKPIByOrgVariables {
  orgID: string;
  nextToken: NextToken;
}

const fetchKPIs = async (): Promise<any> => {
  const fetchKPIsQuery = gql`
    query ListKPIRulesByOrg($orgID: ID, $nextToken: String) {
      listKPIRulesByOrg(
        orgID: $orgID
        filter: { isDeleted: { eq: false } }
        limit: 1000
        nextToken: $nextToken
      ) {
        items {
          id
          title
          abbreviation
          sourceType
          formula
          triggerID
          dimensions
          categoryID
          order
          format
          isHidden
        }
        nextToken
      }
    }
  `;

  try {
    let KPIs: KPIRulePartial[] = [];
    let nextToken: NextToken = null;
    do {
      const KPIsRes = (await API.graphql(
        graphqlOperation(fetchKPIsQuery, {
          //  @ts-ignore
          orgID: global.me.orgID,
          nextToken,
        } as ListKPIByOrgVariables)
      )) as { data: ListKPIByOrgResponse };

      const KPIsItems = KPIsRes.data?.listKPIRulesByOrg?.items ?? [];
      KPIs = [...KPIs, ...KPIsItems];
      nextToken = KPIsRes.data?.listKPIRulesByOrg?.nextToken;
    } while (nextToken);

    return KPIs;
  } catch (err) {
    console.error('Error fetching KPIs:', err);
    throw err;
  }
};

export default fetchKPIs;
